<template>
<el-card class="box-card" shadow="hover">
  <div slot="header" class="clearfix" style="position:relative">
    <el-breadcrumb>
      <el-breadcrumb-item :to="{ path: 'administratorList' }">角色设置</el-breadcrumb-item>
      <el-breadcrumb-item>编辑角色</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="text item">
    <el-form ref="form" :model="form" label-width="140px">
      <p class="dividerLine">基础信息</p>
      <el-form-item label="账号" :required="true">
        <el-input v-model="form.name" placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item label="密码" :required="true">
        <el-input type="password" v-model="form.password" placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" :required="true">
        <el-input type="password" v-model="form.repassword" placeholder="请再次输入密码"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="form.status" placeholder="状态">
          <el-option label="启用" value="1">启用</el-option>
          <el-option label="禁用" value="2">禁用</el-option>
        </el-select>
      </el-form-item>
      <p class="dividerLine">角色</p>
      <el-form ref="form" :model="form" label-width="140px">
        <el-form-item label="角色">
          <el-radio-group v-model="form.roleid">
            <el-radio :label="0" v-show="showBtn<1">超级管理员</el-radio>
            <el-radio :label="3" v-show="showBtn<1">采购员</el-radio>
            <el-radio :label="1">子公司</el-radio>
            <el-radio :label="4">子公司负责人</el-radio>
            <el-radio :label="5">收货员</el-radio>
            <el-radio :label="2">供应商</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <!-- <el-form-item label="" v-if="form.roleid===0">
        <el-checkbox-group v-for="(v,k) in tableData" :key="k" v-model="form.powerList">
          <el-checkbox disabled @change="powerChange(0,v.id)" :label="v.id">{{v.name}}：</el-checkbox>
          <el-checkbox disabled @change="powerChange(1,val.id)" v-for="(val,key) in v.child" :label="val.id" :key="key">{{val.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="" v-else>
        <el-checkbox-group v-for="(v,k) in tableData" :key="k" v-model="form.powerList">
          <el-checkbox @change="powerChange(0,v.id)" :label="v.id">{{v.name}}：</el-checkbox>
          <el-checkbox @change="powerChange(1,val.id)" v-for="(val,key) in v.child" :label="val.id" :key="key">{{val.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item> -->
      <el-row v-if="form.roleid===1||form.roleid===4||form.roleid===5">
        <p class="dividerLine">子公司信息</p>
        <el-form-item label="公司名称">
          <!-- <el-input v-model="form.company" placeholder="请输入公司名称"></el-input> -->
          <el-autocomplete
            class="inline-input"
            v-model="form.company"
            :fetch-suggestions="querySearch"
            placeholder="请输入公司名称"
            @select="handleSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="form.address" placeholder="请输入地址"></el-input>
        </el-form-item>
        <el-form-item label="传真">
          <el-input v-model="form.fax" placeholder="请输入传真"></el-input>
        </el-form-item>
        <el-form-item label="联系人" v-if="form.roleid==1">
          <el-input v-model="form.contacts" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" v-if="form.roleid==1">
          <el-input v-model="form.phone" placeholder="请输入联系人电话"></el-input>
        </el-form-item>
        <el-form-item label="联系人" v-if="form.roleid==5">
          <el-input v-model="form.contacts1" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" v-if="form.roleid==5">
          <el-input v-model="form.phone1" placeholder="请输入联系人电话"></el-input>
        </el-form-item>
        <el-form-item label="批准人">
          <el-input v-model="form.ratifier" placeholder="请输入批准人"></el-input>
        </el-form-item>
        <el-form-item label="批准人电话">
          <el-input v-model="form.ratphone" placeholder="请输入批准人电话"></el-input>
        </el-form-item>
        <el-form-item label="交货地点">
          <el-input v-model="form.deliveryPlace" placeholder="请输入交货地点"></el-input>
        </el-form-item>
      </el-row>
      <el-row v-if="form.roleid===2">
        <p class="dividerLine">供应商</p>
        <el-form-item label="公司名称">
          <!-- <el-input v-model="form.company" placeholder="请输入公司名称"></el-input> -->
          <el-autocomplete
            class="inline-input"
            v-model="form.company"
            :fetch-suggestions="querySearch"
            placeholder="请输入公司名称"
            @select="handleSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="form.address" placeholder="请输入地址"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="传真">
          <el-input v-model="form.fax" placeholder="请输入传真"></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="form.contacts" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="form.phone" placeholder="请输入联系人电话"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码">
          <el-input v-model="form.uniform_social_credit_code" placeholder="请输入统一社会信用代码"></el-input>
        </el-form-item>
        <el-form-item label="银行账号">
          <el-input v-model="form.bank_account" placeholder="请输入银行账号"></el-input>
        </el-form-item>
        <el-form-item label="开户银行">
          <el-input v-model="form.bank" placeholder="请输入开户银行"></el-input>
        </el-form-item>
        <el-form-item label="付款方式">
          <el-input v-model="form.payType" placeholder="请输入付款方式"></el-input>
        </el-form-item>
      </el-row>
      <!-- <el-row v-if="form.roleid==3">
        <el-form-item label="供应商">
          <el-checkbox-group v-model="form.supplier">
            <el-checkbox v-for="(val, key) in supplier" :key="key" :label="val.companyid">{{val.company}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-row>
      <el-row v-if="form.roleid==3">
        <el-form-item label="子公司">
          <el-checkbox-group v-model="form.subsidiary">
            <el-checkbox v-for="(val, key) in subsidiary" :key="key" :label="val.id">{{val.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-row> -->
      <el-form-item label="">
        <el-button @click="editUser" type="primary">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</el-card>
</template>
<script>
import userFunction from "@/api/user"
export default {
  data() {
    return {
      showBtn:sessionStorage.getItem('roleid'),
      tableData:[],
      allPowerList:[],
      supplier:[],
      subsidiary:[],
      form:{
        id:'',
        name:'',
        password:'',
        repassword:'',
        roleid:0,
        company:'',
        address:'',
        email:'',
        fax:'',
        contacts:'',
        phone:'',
        contacts1:'',
        phone1:'',
        ratifier:'',
        ratphone:'',
        deliveryPlace:'',
        uniform_social_credit_code:'',
        bank_account:'',
        bank:'',
        payType:'',
        powerList:[],
        supplier:[],
        subsidiary:[],
        companyid:'',
        status:"1",
        vcode:sessionStorage.getItem('token'),
      }
    }
  },
  methods:{
    querySearch(queryString, cb) {
      userFunction.getCompany({words:queryString,vcode:sessionStorage.getItem('token')},this).then((res) => {
        console.log(res)
        cb(res)
      })
    },
    handleSelect(item) {
      this.form.companyid = item.id
      this.form.address = item.address
      this.form.email = item.email
      this.form.fax = item.fax
      this.form.contacts = item.contacts
      this.form.phone = item.phone
      this.form.contacts1 = item.contacts1
      this.form.phone1 = item.phone1
      this.form.ratifier = item.ratifier
      this.form.ratphone = item.ratphone
      this.form.deliveryPlace = item.deliveryPlace
      this.form.uniform_social_credit_code = item.uniform_social_credit_code
      this.form.bank_account = item.bank_account
      this.form.bank = item.bank
      this.form.payType = item.payType
    },
    powerChange(n,m){
      var powerList = this.form.powerList;
      var testStr = ',' + powerList.join(",") + ",";
      var data = this.tableData;
      if(testStr.indexOf("," + m + ",") != -1){
        if(n==1){
          Object.keys(data).forEach(function(key){
            if(data[key].child){
              var data1 = data[key].child,i=0,j=0;
              Object.keys(data1).forEach(function(a){
                i++;
                if(testStr.indexOf("," + data1[a].id + ",") != -1){
                  j++;
                }
              })
              if(i==j){
                powerList.push(data[key].id);
              }
            }
          });
        }else if(n==0){
          Object.keys(data).forEach(function(key){
              if(m == data[key].id){
                if(data[key].child){
                  var data1 = data[key].child;
                  Object.keys(data1).forEach(function(a){
                    if(testStr.indexOf("," + data1[a].id + ",") === -1){
                      powerList.push(data1[a].id);
                    }
                  });
                }
              }
          });
        }
      }else{
        var undata = [];
        if(n==1){
          Object.keys(data).forEach(function(key){
            if(data[key].child){
              var data1 = data[key].child;
              Object.keys(data1).forEach(function(a){
                if(m == data1[a].id){
                  if(testStr.indexOf("," + data[key].id + ",") != -1){
                    undata.push(data[key].id);
                  }
                }
              })
            }
            Object.keys(undata).forEach(function(b){
              testStr = testStr.replace(new RegExp(','+undata[b]+',',"gm"),',')
            });
          });
        }else if(n==0){
          undata = [];
          Object.keys(data).forEach(function(key){
              if(m == data[key].id){
                if(data[key].child){
                  var data1 = data[key].child;
                  Object.keys(data1).forEach(function(a){
                    if(testStr.indexOf("," + data1[a].id + ",") != -1){
                      undata.push(data1[a].id);
                    }
                  });
                }
              }
              Object.keys(undata).forEach(function(b){
                testStr = testStr.replace(new RegExp(','+undata[b]+',',"gm"),',')
              });
          });
        }
        powerList = [];
        var newdata = testStr.split(',');
        for(var c=0;c<newdata.length;c++){
          if(newdata[c]!=''){
            powerList.push(parseInt(newdata[c]));
          }
        }
      }
      var newpowerlist = [];
      for(var i = 0; i < powerList.length; i++){
          if(newpowerlist.indexOf(powerList[i]) == -1){
              newpowerlist.push(powerList[i])
          }
      }
      this.form.powerList = newpowerlist;
    },
    getPowerList(){
      var that = this
      userFunction.getPowerList({
        vcode:sessionStorage.getItem('token')
      },this).then((res) => {
        this.tableData = res
        var powerList = []
        Object.keys(res).forEach(function(key){
          powerList.push(res[key].id)
          if(res[key].child){
            for(var i=0;i<res[key].child.length;i++){
              powerList.push(res[key].child[i].id)
            }
          }
          that.allPowerList = powerList
        });
      })
    },
    addUser(){
      if(this.form.name==''){
        this.$message.error('账号不能为空')
        return false
      }
      if(this.form.password==''){
        this.$message.error('密码不能为空')
        return false
      }
      if(this.form.password!=''&&this.form.password!=this.form.repassword){
        this.$message.error('密码和确认密码不一致')
        return false
      }
      userFunction.addUser(this.form,this).then((res) => {
        //this.$router.push('/home/administratorList')
        this.$router.back(0)
      })
    },
    getUser(){
      userFunction.getUser({vcode:sessionStorage.getItem('token'),id:this.form.id},this).then((res) => {
        this.form.name = res.name
        this.form.powerList = res.powerList
        this.form.address = res.address
        this.form.bank = res.bank
        this.form.bank_account = res.bank_account
        this.form.company = res.company
        this.form.contacts = res.contacts
        this.form.deliveryPlace = res.deliveryPlace
        this.form.email = res.email
        this.form.fax = res.fax
        this.form.payType = res.payType
        this.form.phone = res.phone
        this.form.ratifier = res.ratifier
        this.form.ratphone = res.ratphone
        this.form.uniform_social_credit_code = res.uniform_social_credit_code
        this.form.roleid = res.role_id
        this.form.supplier = res.supplier
        this.form.subsidiary = res.subsidiary
        this.form.companyid = res.companyid
        this.form.status = res.status
      })
    },
    editUser(){
      userFunction.editUser(this.form,this).then((res) => {
        //this.$router.push('/home/administratorList')
        this.$router.back()
      })
    },
    getSupplier(){
      userFunction.getSupplier({vcode:sessionStorage.getItem('token')},this).then((res) => {
        this.supplier = res
      })
    },
    getsubsidiary(){
      userFunction.getsubsidiary({vcode:sessionStorage.getItem('token')},this).then((res) => {
        this.subsidiary = res
      })
    }
  },
  watch:{
    'form.roleid'(val) {
      if(val===0){
        this.form.powerList = this.allPowerList
      }
    }
  },
  mounted () {
    this.getPowerList()
    this.form.id = this.$route.query.id
    this.getUser()
    // this.getSupplier()
    // this.getsubsidiary()
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/user/editUser.vue